import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MsalProvider, AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import { ContentProvider } from '../context/ContentContext';
import { ContentListPage } from '../pages/ContentList/ContentList';
import { RunProgressPage } from '../pages/RunProgress/RunProgress';
import { Header } from '../components/Header/Header';
import Login from '../pages/Login/Login';
import '../styles/index.css';

function App({ instance }) {
  useEffect(() => {
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0 && !instance.getActiveAccount()) {
      instance.setActiveAccount(accounts[0]);
    }
  }, [instance]);

  return (
    <MsalProvider instance={instance}>
      <ContentProvider>
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route 
              path="/" 
              element={
                <>
                  <AuthenticatedTemplate>
                    <ContentListPage />
                  </AuthenticatedTemplate>
                  <UnauthenticatedTemplate>
                    <Navigate to="/login" replace />
                  </UnauthenticatedTemplate>
                </>
              } 
            />

            <Route 
              path="/run-progress" 
              element={
                <>
                  <AuthenticatedTemplate>
                    <RunProgressPage />
                  </AuthenticatedTemplate>
                  <UnauthenticatedTemplate>
                    <Navigate to="/login" replace />
                  </UnauthenticatedTemplate>
                </>
              } 
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </MsalProvider>
  );
}

export default App;